import { useEffect, useState } from 'react';
import ThemeMaker from '../../components/thememaker';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { config } from "../../utils/config";
import axios from 'axios';
import { Paginated } from '../../components/Paginated';
import CircularProgress from '@mui/material/CircularProgress';
import Cookies from 'js-cookie';
import { baseUrlDefiner } from '../../utils/config';
export default function Productlist() {
    const { apiEndpoint } = config;
    const [productTypes, setproductTypes] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [searchHandler, setsearchHandler] = useState("");

    useEffect(() => {
        if (searchHandler === "") {
            getproductTypes()
        } else {
            let timer = setTimeout(() => {
                let allProductTypes = [...productTypes]
                let searchItem = searchHandler.toLowerCase().trim()
                let filteredItems = allProductTypes.filter((item: any) => item.name.toLowerCase().trim().includes(searchItem))
                setproductTypes([...filteredItems])
            }, 1000)

            return () => clearTimeout(timer);

        }

    }, [searchHandler])

    async function getproductTypes() {
        let apiEndpoint = baseUrlDefiner();
        try {
            setIsLoading(true)
            const { data } = await axios({
                url: `${apiEndpoint}/getProtypeList`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },

            })
            console.log(data)
            if (data.status === 200) {
                setproductTypes(data?.data)
                setIsLoading(false)
            } else {
                toast.error("Error In Loading Product Type");

            }
        } catch (err) {
            setIsLoading(false)
            toast.error("Error in API")
        }
    }
    async function deleteHandler(id: any) {
        let apiEndpoint = baseUrlDefiner();
        try {
            setIsLoading(true)
            const { data } = await axios({
                url: `${apiEndpoint}/deleteprotype`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,
                },
                data: {
                    id
                }

            })

            if (data.status === 200) {
                toast.success("Deleted Successfully");
                setTimeout(() => {
                    getproductTypes()
                }, 1000)
            } else {
                toast.error("Error In Deleting Product Type");

            }
        } catch (err) {
            setIsLoading(false)
            toast.error("Error in API")
        }
    }

    const COLUMNS = [
        {
            Header: "Sn No.",
            Footer: "Sn No.",
            accessor: (row: any, count: any) => {
                return <>{count + 1}</>
            },
            disableFilters: true,
            sticky: "left"
        },
        {
            Header: "Name",
            Footer: "Name",
            accessor: "name",
            sticky: "left"
        },
        {
            Header: "ONDC Mapping",
            Footer: "ONDC Mapping",
            accessor: "ondc_mapping",
            sticky: "Status"
        },
        {
            Header: "Status",
            Footer: "Status",
            accessor: (row: any) => {
                return row.status === true ? 'Active' : "Inactive"
            },
            sticky: "Status"
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: (row: any) => {
                return (
                    <>
                        <Link to={`/producttype/${row.id}`} className="btn btn-success btn-circle"> <i className="fas fa-eye"></i></Link> <button className="btn btn-danger btn-circle" onClick={() => deleteHandler(row.id)} ><i className="fas fa-trash"></i></button>
                    </>
                )
            },
            sticky: "left"
        },



    ];


    return (
        <ThemeMaker>
            <div className="row w-100 m-0 mt-1">
                <div className="col-md-12 ">
                    <div className="card shadow mb-4">
                        <div className="card-header py-3">
                            <h6 className="m-0 font-weight-bold text-primary text-left d-flex justify-content-between align-items-center">
                                <span> Product Type List</span>

                                <div className='d-flex  align-items-center' style={{ gap: "20px" }}>

                                    <input type="text" className='form-control' placeholder='Search Product Type' onChange={(e) => {
                                        setsearchHandler(e.target.value)
                                    }} />

                                    <Link to="/producttype">   <button className="btn btn-primary " style={{ width: "200px" }}>Add Product Type</button>
                                    </Link>

                                </div>


                            </h6>
                        </div>

                        <div className="card-body" style={{ minHeight: "70vh" }}>

                            {!isLoading ? <Paginated data={productTypes} columns={COLUMNS} /> : <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}><CircularProgress /></div>}
                        </div>
                    </div>
                </div>
            </div>

        </ThemeMaker >
    )
}
